import type { DataTableV2ColumnVisibilityState } from '../../../features/ColumnVisibility/ColumnVisibility.js';

/**
 * Props for the DataTableV2ColumnVisibilitySettings component.
 * @public
 */
export interface DataTableV2ColumnVisibilitySettingsProps {
  /**
   * Column visibility reset state that will be used to reset and also to enable/disable 'Reset to default'
   * in column settings modal.
   */
  resetColumnVisibility?: DataTableV2ColumnVisibilityState;
}

/**
 * The slot component serves the sole purpose of detecting the user's intention to display column visibility within the column settings modal, situated in the DataTableV2 toolbar.
 * @public
 */
export const DataTableV2ColumnVisibilitySettings = ({
  resetColumnVisibility,
}: DataTableV2ColumnVisibilitySettingsProps) => null;

DataTableV2ColumnVisibilitySettings.displayName =
  'DataTableV2.VisibilitySettings';
